var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "customcheckerboard-size-selector"
  }, [_c('div', {
    class: ['customcheckerboard-size-selector-body', 'customcheckerboard-main-views-wrapper-body']
  }, [_c('h5', {
    class: ['customcheckerboard-size-selector-title', 'customcheckerboard-main-views-wrapper-title', 'text-center']
  }, [_vm._v(_vm._s(_vm.translations.customCheckerboardSizeTitle))]), _c('div', {
    staticClass: "customcheckerboard-size-selector-choose-sizes"
  }, _vm._l(_vm.checkerboardSize, function (item, size) {
    return _c('div', {
      key: item.label,
      staticClass: "customcheckerboard-size-selector-item"
    }, [_c('div', {
      class: ['customcheckerboard-size-selector-image', {
        'customcheckerboard-size-selector-image-active': size === _vm.selectedSize
      }],
      on: {
        "click": function click($event) {
          return _vm.selectSize(size, item.dataLayerName);
        }
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: size === _vm.selectedSize,
        expression: "size === selectedSize"
      }],
      staticClass: "customcheckerboard-size-selector-icon-check icon-check"
    }), _c('checkerboard-fabric-canvas', {
      attrs: {
        "tileConfig": item.tileConfig,
        "color1": _vm.canvasConfig.color1,
        "color2": _vm.canvasConfig.color2,
        "canvasWidth": _vm.canvasWidth,
        "canvasHeight": 91
      },
      on: {
        "canvasLoaded": _vm.canvasLoaded
      }
    })], 1), _c('span', {
      staticClass: "customcheckerboard-size-selector-label text-center"
    }, [_vm._v(_vm._s(_vm.translations[item.label]))])]);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }